import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ParseError, parsePhoneNumberWithError } from 'libphonenumber-js/min';
import { LocaleService } from 'src/app/services/locale/locale-service';
import { NationPhoneCodes } from './../../../../utils/utils';

export interface ConvertedPhoneNumber {
  callingCode: string;
  country: string | undefined;
  number: string;
  isValid: boolean;
}

@Component({
  selector: 'app-phone-input',
  templateUrl: './phone-input.component.html',
  styleUrls: ['./phone-input.component.scss'],
})
export class PhoneInputComponent implements OnInit {

  @Input() phoneNumber = '';
  @Input() nationCode = '';
  @Output() phoneNumberChanged = new EventEmitter<string>();
  @Output() isValid = new EventEmitter<boolean>();
  @Output() convertedPhoneNumber = new EventEmitter<ConvertedPhoneNumber>();
  nationCodeList: {
    callingCode: string;
    countryName: {
      ko: string;
      en: string;
    }
  }[] = NationPhoneCodes;

  isKorea = this.isLocaleKo;

  get isLocaleKo(): boolean {
    return this.localeService.isKo
  }

  constructor(
    private localeService: LocaleService
  ) { }

  ngOnInit() {
  }

  onClickInputOtherCountry(): void {
    this.isKorea = false;
  }

  onChangeNationCode(event: Event): void {
    this.convertToInternationalFormat();
  }

  onChangePhoneNumber(value: string): void {
    this.convertToInternationalFormat();
  }

  onClickDeleteValue(): void {
    this.phoneNumber = '';
    this.convertToInternationalFormat();
  }

  private convertToInternationalFormat(): void {
    try {
      // default: 한국 calling code
      const nationCode = this.nationCode ? this.nationCode : this.isKorea ? '+82' : '+1';
      const phoneNumber = parsePhoneNumberWithError(`${nationCode} ${this.phoneNumber}`);
      const { countryCallingCode, number, country } = phoneNumber;
      this.convertedPhoneNumber.emit({
        callingCode: countryCallingCode,
        number,
        isValid: phoneNumber.isValid(),
        country
      });
    } catch (error) {
      this.convertedPhoneNumber.emit({
        callingCode: '',
        number: this.phoneNumber ?? '',
        country: '',
        isValid: false
      })
      if (error instanceof ParseError) {
        this.handleConvertingError(error);
      } else {
        throw error;
      }
    }
  }

  private handleConvertingError(error: ParseError): void {
    const { message } = error;
    switch (message) {
      case 'NOT_A_NUMBER':
      case 'INVALID_COUNTRY':
      case 'TOO_SHORT':
      case 'TOO_LONG':
    }
  }
}

